import { render, staticRenderFns } from "./CapacitanceItems.vue?vue&type=template&id=59965496&scoped=true&"
import script from "./CapacitanceItems.vue?vue&type=script&lang=js&"
export * from "./CapacitanceItems.vue?vue&type=script&lang=js&"
import style0 from "./CapacitanceItems.vue?vue&type=style&index=0&id=59965496&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59965496",
  null
  
)

export default component.exports